import styled from 'styled-components'

export const ButtonGroup = styled.div`
	display: flex;
	align-items: flex-end;
	overflow-x: auto;
`
